import { createSlice } from '@reduxjs/toolkit';

const authentication = createSlice({
  name: 'authentication',
  initialState: {
    loginLoading: false,
    signupLoading: false,
    loginError: null,
    signupError: null,
    mfaInitError: null,
    data: null,
  },
  reducers: {
    loginRequest(state) {
      state.loginLoading = true;
    },
    loginSuccess(state, { payload }) {
      state.loginLoading = false;
    },
    loginFailure(state) {
      state.loginLoading = false;
    },
    signupRequest(state) {
      state.signupLoading = true;
    },
    signupSuccess(state, { payload }) {
      state.signupLoading = false;
    },
    signupFailure(state) {
      state.signupLoading = false;
    },
    mfaInitFailure(state, { payload }) {
      state.mfaInitError = payload;
    },
    mfaVerifyRequest(state) {
      state.mfaVerifyLoading = true;
    },
    mfaVerifySuccess(state, { payload }) {
      state.mfaVerifyLoading = false;
    },
    mfaVerifyFailure(state) {
      state.mfaVerifyLoading = false;
    },
  },
});

const { actions, reducer } = authentication;

export const {
  loginRequest,
  loginSuccess,
  loginFailure,
  signupRequest,
  signupSuccess,
  signupFailure,
  mfaInitFailure,
  mfaVerifyRequest,
  mfaVerifySuccess,
  mfaVerifyFailure,
} = actions;

export default reducer;
